/**
 * Size guide unit switching.
 *
 * Shared by the product-page popup (blocks/size-guide.liquid) and the standalone
 * size guide page (sections/size-guide-page.liquid). It lives in an asset rather
 * than a {% javascript %} tag because those are only delivered when their block
 * renders — a section on a page template would not receive the block's script.
 *
 * Loaded as a module from both, so the browser fetches and executes it once even
 * when both are present.
 */

const SIZE_GUIDE_UNIT_KEY = 'size-guide-unit';

function applySizeGuideUnit(root, unit) {
  root.dataset.unit = unit;
  root.querySelectorAll('.size-guide__unit').forEach((button) => {
    const isActive = button.dataset.unit === unit;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
  });
}

function storedSizeGuideUnit() {
  try {
    const stored = localStorage.getItem(SIZE_GUIDE_UNIT_KEY);
    return stored === 'in' || stored === 'cm' ? stored : null;
  } catch {
    return null;
  }
}

// Restore the shopper's last choice so it persists across products and pages.
function restoreSizeGuideUnits() {
  const unit = storedSizeGuideUnit();
  if (!unit) return;
  document.querySelectorAll('.size-guide').forEach((root) => applySizeGuideUnit(root, unit));
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.size-guide__unit');
  if (!button) return;

  const root = button.closest('.size-guide');
  if (!root) return;

  applySizeGuideUnit(root, button.dataset.unit);

  try {
    localStorage.setItem(SIZE_GUIDE_UNIT_KEY, button.dataset.unit);
  } catch {
    // Private browsing — the choice just won't persist.
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', restoreSizeGuideUnits);
} else {
  restoreSizeGuideUnits();
}
